import type { CommandLabel } from '@wiztime/storage';
import type { TFunction } from 'i18next';
import type { StepDetail } from './undoDescribe';

/**
 * One line naming an undo step: "check-in · Drink water → unticked". Without a nameable object
 * only the command's name remains; without a flipped state only the object follows it.
 */
export function stepText(t: TFunction, label: CommandLabel, detail: StepDetail): string {
  const name = t(`command.${label}`);
  const state = detail.state === null ? null : t(`undo.state.${detail.state}`);
  const body =
    detail.subject !== null && state !== null
      ? t('undo.subjectState', { subject: detail.subject, state })
      : (detail.subject ?? state);
  return body === null ? name : t('undo.withDetail', { label: name, detail: body });
}
